import React from 'react'
import PropTypes from 'prop-types'
import ReactSimpleRange from 'react-simple-range'
import styled from 'styled-components'
const Range = ({id, value, min, max, step, onChange, sliderColor, trackColor}) => {


    return (
        <RangeInputWrapper>
            <ReactSimpleRange
                id={id}
                value={value}
                min={min}
                max={max}
                step={step}
                sliderSize={8}
                thumbSize={21}
                onChange={onChange}
                sliderColor={sliderColor}
                trackColor={trackColor}
                thumbColor={trackColor}/>
        </RangeInputWrapper>
    )
}

Range.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    sliderColor: PropTypes.string.isRequired,
    trackColor: PropTypes.string.isRequired,
}

export default Range

const RangeInputWrapper = styled.div`
    padding: 0 10px;
    & > div > div {
        border-radius: 10px;
    }
    & > div > div > div {
        border-radius: 10px;
        transition: left .2s ease, width .2s ease;
    } 
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/Range.jsx